export default __webpack_public_path__ + "static/media/Vanessa_9781408315910.6c3776d4.jpg";